import type React from "react";

import { RING_SEGMENTS_COUNT } from "../../lib/constants";

import styles from "./styles.module.scss";

import type { IndicatorState } from "../../hooks/useVerificationFlow";

interface IndicatorRingProps {
  state: IndicatorState;
  faceClass?: string;
}

const CURRENT_ANGLE_PROXIMITY = 5;

function getIndicatorModifier(index: number, state: IndicatorState): string {
  if (state.mode === "circled") return "";
  const angle = (index / RING_SEGMENTS_COUNT) * 360;
  const isActive = state.activeAngles.some(
    (a) => Math.min(Math.abs(a - angle), 360 - Math.abs(a - angle)) < 0.5,
  );

  if (
    state.currentAngle !== undefined &&
    Math.min(
      Math.abs(angle - state.currentAngle),
      360 - Math.abs(angle - state.currentAngle),
    ) < CURRENT_ANGLE_PROXIMITY
  ) {
    return styles.current;
  }

  if (state.mode === "loading" && isActive) return styles.loading;
  if (state.mode === "error") return styles.error;
  if (state.mode === "active" || (state.mode === "idle" && isActive))
    return styles.active;
  return "";
}

export function IndicatorRing({ state, faceClass = "" }: IndicatorRingProps) {
  const isCircled = faceClass.includes("circled");

  return (
    <div id="face" className={`${styles.faceIndicators} ${faceClass}`}>
      {!isCircled && (
        <div id="indicators" className={styles.indicators}>
          {Array.from({ length: RING_SEGMENTS_COUNT }, (_, i) => {
            const mod = getIndicatorModifier(i, state);
            return (
              <span
                key={i}
                className={`${styles.indicator} ${mod}`}
                style={
                  {
                    "--rotation": (i / RING_SEGMENTS_COUNT) * 360,
                  } as React.CSSProperties
                }
              >
                <span />
              </span>
            );
          })}
        </div>
      )}
      <div
        id="indicators-circle"
        className={`${styles.indicatorsCircle} ${isCircled ? styles.ringVisible : ""} ${faceClass.includes("active") ? styles.ringActive : ""}`}
      />
    </div>
  );
}
